import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.reduce.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Range } from '../../../common/range.js';
/**
 * Returns the intersection between a ranged group and a range.
 * Returns `[]` if the intersection is empty.
 */

export function groupIntersect(range, groups) {
  var result = [];

  var _iterator = _createForOfIteratorHelper(groups),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var r = _step.value;

      if (range.start >= r.range.end) {
        continue;
      }

      if (range.end < r.range.start) {
        break;
      }

      var intersection = Range.intersect(range, r.range);

      if (Range.isEmpty(intersection)) {
        continue;
      }

      result.push({
        range: intersection,
        size: r.size
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}
/**
 * Shifts a range by that `much`.
 */

export function shift(_ref, much) {
  var start = _ref.start,
      end = _ref.end;
  return {
    start: start + much,
    end: end + much
  };
}
/**
 * Consolidates a collection of ranged groups.
 *
 * Consolidation is the process of merging consecutive ranged groups
 * that share the same `size`.
 */

export function consolidate(groups) {
  var result = [];
  var previousGroup = null;

  var _iterator2 = _createForOfIteratorHelper(groups),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var group = _step2.value;
      var start = group.range.start;
      var end = group.range.end;
      var size = group.size;

      if (previousGroup && size === previousGroup.size) {
        previousGroup.range.end = end;
        continue;
      }

      previousGroup = {
        range: {
          start: start,
          end: end
        },
        size: size
      };
      result.push(previousGroup);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return result;
}
/**
 * Concatenates several collections of ranged groups into a single
 * collection.
 */

function concat() {
  for (var _len = arguments.length, groups = new Array(_len), _key = 0; _key < _len; _key++) {
    groups[_key] = arguments[_key];
  }

  return consolidate(groups.reduce(function (r, g) {
    return r.concat(g);
  }, []));
}

export var RangeMap = /*#__PURE__*/function () {
  function RangeMap() {
    _classCallCheck(this, RangeMap);

    this.groups = [];
    this._size = 0;
  }

  _createClass(RangeMap, [{
    key: "splice",
    value: function splice(index, deleteCount) {
      var items = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var diff = items.length - deleteCount;
      var before = groupIntersect({
        start: 0,
        end: index
      }, this.groups);
      var after = groupIntersect({
        start: index + deleteCount,
        end: Number.POSITIVE_INFINITY
      }, this.groups).map(function (g) {
        return {
          range: shift(g.range, diff),
          size: g.size
        };
      });
      var middle = items.map(function (item, i) {
        return {
          range: {
            start: index + i,
            end: index + i + 1
          },
          size: item.size
        };
      });
      this.groups = concat(before, middle, after);
      this._size = this.groups.reduce(function (t, g) {
        return t + g.size * (g.range.end - g.range.start);
      }, 0);
    }
    /**
     * Returns the number of items in the range map.
     */

  }, {
    key: "count",
    get: function get() {
      var len = this.groups.length;

      if (!len) {
        return 0;
      }

      return this.groups[len - 1].range.end;
    }
    /**
     * Returns the sum of the sizes of all items in the range map.
     */

  }, {
    key: "size",
    get: function get() {
      return this._size;
    }
    /**
     * Returns the index of the item at the given position.
     */

  }, {
    key: "indexAt",
    value: function indexAt(position) {
      if (position < 0) {
        return -1;
      }

      var index = 0;
      var size = 0;

      var _iterator3 = _createForOfIteratorHelper(this.groups),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var group = _step3.value;
          var count = group.range.end - group.range.start;
          var newSize = size + count * group.size;

          if (position < newSize) {
            return index + Math.floor((position - size) / group.size);
          }

          index += count;
          size = newSize;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return index;
    }
    /**
     * Returns the index of the item right after the item at the
     * index of the given position.
     */

  }, {
    key: "indexAfter",
    value: function indexAfter(position) {
      return Math.min(this.indexAt(position) + 1, this.count);
    }
    /**
     * Returns the start position of the item at the given index.
     */

  }, {
    key: "positionAt",
    value: function positionAt(index) {
      if (index < 0) {
        return -1;
      }

      var position = 0;
      var count = 0;

      var _iterator4 = _createForOfIteratorHelper(this.groups),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var group = _step4.value;
          var groupCount = group.range.end - group.range.start;
          var newCount = count + groupCount;

          if (index < newCount) {
            return position + (index - count) * group.size;
          }

          position += groupCount * group.size;
          count = newCount;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return -1;
    }
  }]);

  return RangeMap;
}();